<ng-template let-context let-modal="modal" #modalTemplate>
    <div class="header">
        <div class="ui grid desktop">
            <div class="ui eight wide column">
                <h3>Réservation de votre location</h3>
            </div>
            <div class="ui five wide column" >
                <p class="available-location">Nombre de véhicules disponibles: {{nbVans}}</p>
            </div>
            <div class="ui three wide column">
                <button class="ui icon button arrow-button location-selection button-selection-left" (click)="previousVan()">
                    <i class="arrow left icon"></i>
                </button>
                <p class="available-location location-selection">{{currentVan.Position()}}</p>
                <button class="ui icon button arrow-button location-selection button-selection-right" (click)="nextVan()">
                    <i class="arrow right icon"></i>
                </button>
            </div>
        </div>
        <div class="ui grid smartphone">
            <div class="ui eight wide column" >
                <p class="available-location">Véhicules disponibles: {{nbVans}}</p>
            </div>
            <div class="ui eight wide column">
                <button class="ui icon button arrow-button location-selection button-selection-left" (click)="previousVan()">
                    <i class="arrow left icon"></i>
                </button>
                <p class="available-location location-selection">{{currentVan.Position()}}</p>
                <button class="ui icon button arrow-button location-selection button-selection-right" (click)="nextVan()">
                    <i class="arrow right icon"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="content">
        <div>
            <leasing-userCalendar [calendar]="calendar"
                                  (slotSelected)="onSlotSelected($event)"
                                  (slotUnSelected)="onSlotUnSelected($event)"></leasing-userCalendar>
        </div>
    </div>
    <div class="actions">
        <div class="ui equal width grid">
            <div class="ui column calendar-buttons">
                <div>
                    <button class="ui button" (click)="cancel(modal)">Annuler</button>
                    <button class="ui primary button" (click)="update(modal)" autofocus>Modifier</button>
                </div>
            </div>
        </div>
    </div>
    <error-popup></error-popup>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/unavailability/unavailability.html